import { TheWrapper } from '@hyphengroup/cms-components/components/TheWrapper';
import InfoCard from '../components-internal/InfoCard';
import { ComponentInfoCardsFaq } from '$/(cms)/_modules/cmsService/types';

export const InfoCardsFAQ: React.FC<ComponentInfoCardsFaq> = ({
  id,
  faqs,
  title,
}) => {
  return (
    <TheWrapper type="simple">
      <div className="mx-auto max-w-screen-2xl gap-4 2xl:gap-6">
        <h3 className="mb-4 alpha-display-2 lg:mb-6">{title}</h3>
        <div className="mx-auto w-full gap-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
            {faqs?.map((item) => (
              <InfoCard
                key={id}
                type="readmore"
                title={item?.title ?? ''}
                description={item?.description ?? ''}
                link={item?.link ?? ''}
              />
            ))}
          </div>
        </div>
      </div>
    </TheWrapper>
  );
};
